import { render, staticRenderFns } from "./EkatenaForm.vue?vue&type=template&id=244534eb&scoped=true&"
import script from "./EkatenaForm.vue?vue&type=script&lang=js&"
export * from "./EkatenaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244534eb",
  null
  
)

export default component.exports